import { render, staticRenderFns } from "./NoticeLawyerChild.vue?vue&type=template&id=60e0a8da"
import script from "./NoticeLawyerChild.vue?vue&type=script&lang=ts"
export * from "./NoticeLawyerChild.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports